const PLANNING_STATES = ['captured', 'shaping', 'shaped', 'parked', 'promoted']
const NEXT_ACTIONS = ['shape', 'research', 'decide', 'promote', 'implement', 'park', 'none']
const STATUSES = ['backlog', 'todo', 'in_progress', 'review', 'done', 'cancelled']
const STRUCTURED_TAG_VALUES = {
  state: new Set([...PLANNING_STATES, ...STATUSES]),
  planning_state: new Set(PLANNING_STATES),
  next: new Set(NEXT_ACTIONS),
  suggested_next_action: new Set(NEXT_ACTIONS),
  status: new Set(STATUSES),
}

export function visibleTaskTags(tags = []) {
  return (tags || []).filter((tag) => !isReservedStructuredTag(tag))
}

function isReservedStructuredTag(tag) {
  const [rawLabel, ...rawValueParts] = String(tag || '').trim().toLowerCase().split(':')
  const value = rawValueParts.join(':').trim().replaceAll(' ', '_')
  if (!rawLabel || !value) return false

  return STRUCTURED_TAG_VALUES[rawLabel.trim()]?.has(value) || false
}
